import { useEffect } from "react";
import { X, LogIn } from "lucide-react";

/**
 * Shown when a logged-out visitor tries to pay at a store that needs an OTP.
 * onLogin: send the visitor to the login screen
 */
export default function LoginRequiredModal({ open, onClose, onLogin }) {
    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4" role="dialog" aria-modal="true" aria-label="Log in to continue">
            <div className="absolute inset-0 bg-black/50" onClick={onClose} />
            <div className="relative w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute right-4 top-4 rounded-full p-1.5 text-gray-500 transition-colors hover:bg-gray-100"
                    aria-label="Close"
                >
                    <X size={18} />
                </button>
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#0B67FC]/10 text-[#0B67FC]">
                    <LogIn size={22} />
                </span>
                <h2 className="mt-4 text-lg font-bold text-gray-900">Log in to continue</h2>
                <p className="mt-1 text-sm text-gray-600">
                    This store verifies payments with an OTP sent to your mobile number, so you need to be logged in first.
                </p>
                <div className="mt-6 flex gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-1 rounded-xl border border-gray-200 py-3 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onLogin}
                        className="flex-1 rounded-xl bg-[#0B67FC] py-3 text-sm font-bold text-white shadow-sm transition-all hover:bg-[#0954D0] active:scale-[0.99]"
                    >
                        Log in
                    </button>
                </div>
            </div>
        </div>
    );
}